import StatCell from "./StatCell";

export default StatCell;
